import { required } from "vuelidate/lib/validators";
import { Model } from "./Model";
import { Tipo, TipoValidation, TipoNoValidation } from "./Tipo";

class RegimeFederal extends Model {
  constructor() {
    super();
    this.tipo = new Tipo();
    this.irpj = 0;
    this.csll = 0;
    this.pis = 0;
    this.cofins = 0;
    this.impostosFolha = 0;
    this.fatRedServicos = 0;
    this.aliqAdicional = 0;
    this.limiteLucroMes = 0;
    this.combustiveis = 0;
    this.fatRedSudan = 0;
    this.fatRedIrpj = 0;
    this.fatRedCsll = 0;
    this.fatRedServicos = 0;
    this.aliqAdicional = 0;
    this.aliqBcBasa = 0;
    this.aliqPropriaBasa = 0;
    this.vigencia = "";
    this.simples = {};
  }
}

const RegimeFederalValidation = {
  tipo: TipoValidation,
  vigencia: {
    required,
  },
};

const RegimeFederalNoValidation = {
  tipo: TipoNoValidation,
  vigencia: {},
};

export { RegimeFederal, RegimeFederalValidation, RegimeFederalNoValidation };
